/**
 * VIO stores token `icon` and voucher `images[]` as paths like `/uploads/...`.
 * Resolve using (in order): explicit `opts.baseUrl` from GET /checkin/settings `vioPublicBaseUrl`,
 * REACT_APP_VIO_PUBLIC_URL, then origin of REACT_APP_VIO_EXTERNAL_API_URL.
 */
function trimBase(b) {
  return (b || '').trim().replace(/\/$/, '');
}

function pickResolveBase(explicitFromServer) {
  const fromServer = trimBase(explicitFromServer);
  if (fromServer) return fromServer;
  const pub = trimBase(process.env.REACT_APP_VIO_PUBLIC_URL);
  if (pub) return pub;
  const ext = (process.env.REACT_APP_VIO_EXTERNAL_API_URL || '').trim();
  if (!ext) return '';
  try {
    return new URL(ext).origin;
  } catch {
    return '';
  }
}

/**
 * @param {string|null|undefined} raw
 * @param {{ baseUrl?: string }} [opts] - pass `baseUrl` from settings `vioPublicBaseUrl` so Ops matches backend asset resolution
 */
export function resolveVioAssetUrl(raw, opts = {}) {
  if (raw == null) return null;
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  if (/^data:/i.test(s)) return s;

  const base = pickResolveBase(opts.baseUrl);
  if (!base) return s;

  try {
    const path = s.startsWith('/') ? s : `/${s.replace(/^\/+/, '')}`;
    return new URL(path, `${base}/`).href;
  } catch {
    const cleanPath = s.replace(/^\//, '');
    return `${base}/${cleanPath}`;
  }
}

function imageEntryToPath(entry) {
  if (entry == null) return '';
  if (typeof entry === 'string') return entry.trim();
  if (typeof entry === 'object') {
    const u = entry.imageUrl || entry.url || entry.src || entry.path;
    if (typeof u === 'string' && u.trim()) return u.trim();
  }
  return '';
}

/** First displayable image path from normalized voucher `images` (strings or VIO-shaped objects). */
export function firstVoucherImagePath(voucher) {
  const imgs = voucher?.images;
  if (!Array.isArray(imgs) || imgs.length === 0) return '';
  for (const entry of imgs) {
    const p = imageEntryToPath(entry);
    if (p) return p;
  }
  return '';
}
